import React, { PureComponent } from 'react';
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';
import { Form, Input, Button, Icon, Alert } from 'antd';
import { Image } from '../../components';
import { withRedux } from '../../hoc';
import { removeWishlistAction } from '../../actions/quotes';
import { createQuotesApi } from '../../services/quote/quotes';
import { sendMail } from '../../services/mail';
import { json2table, array2table, getServiceUrl } from '../../utils';

const FormItem = Form.Item;

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    auth: _.get(state, 'auth'),
    product: _.get(state, 'product'),
    quotes: _.get(state, 'quotes')
  };
};

const actions = {
  removeWishlistAction
};

@Form.create()
@withRedux(mapStateToProps, actions)
export default class WishlistForm extends PureComponent {
  state = {
    submitting: false,
    errorMessage: null
  };
  handleCloseWishlist = productId => {
    this.props.actions.removeWishlistAction(productId);
  };
  submit = async datas => {
    const { t } = this.props;
    if (this.state.submitting) return false;
    this.setState({ submitting: true, errorMessage: null });
    const createResult = await createQuotesApi(datas);
    if (_.get(createResult, 'status') === 'error') {
      this.setState({ errorMessage: _.get(createResult, 'message'), submitting: false });
      return false;
    }
    const sendMailResult = await sendMail({
      subject: `${t('คุณมีการขอราคาใหม่จาก')} ${_.get(datas, 'user.email')}`,
      html: ReactDOMServer.renderToString(
        <div>
          <h2>User</h2>
          {json2table({
            data: {
              Name: _.get(datas, 'user.fullname'),
              'E-mail': _.get(datas, 'user.email'),
              Telephone: _.get(datas, 'user.mobile'),
              Company: _.get(datas, 'user.company')
            }
          })}
          <h2>Product</h2>
          {array2table({
            data: _.map(JSON.parse(_.get(datas, 'products')), (product, index) => {
              const full_file_path = `${getServiceUrl()}/${_.get(product, 'image.path')}`;
              return {
                '#': index,
                Image: ReactDOMServer.renderToString(
                  <img src={full_file_path} alt={t(_.get(product, 'name'))} width="100" />
                ),
                Name: t(_.get(product, 'name')),
                Model: t(_.get(product, 'model')),
                Brand: t(_.get(product, 'brand.name')),
                Category: t(_.get(product, 'category.name')),
                'Input Quantity': t(_.get(product, 'input_data.quantity')),
                'Input Model': _.get(product, 'input_data.model'),
                'Input Detail': _.get(product, 'input_data.detail')
              };
            })
          })}
        </div>
      )
    });
    console.log('sendMailResult', sendMailResult);
    this.setState({ submitting: false });
    this.props.form.resetFields();
    this.props.onWishlist();
    return true;
  };
  handleSubmitWishlist = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const user = _.get(this.props, 'auth.data');
        const products = _.map(values, (value, productId) => {
          const product = _.get(this.props, `product.products.data.${productId}`);
          return {
            ...product,
            input_data: {
              quantity: _.toInteger(_.get(value, 'quantity')),
              model: _.get(value, 'model'),
              detail: _.get(value, 'detail')
            }
          };
        });
        this.submit({ user, products: JSON.stringify(products) });
      }
    });
  };
  render() {
    const { submitting, errorMessage } = this.state;
    const { t } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmitWishlist} className="wishlist-form">
        {_.map(_.get(this.props, 'quotes.wishlist'), (productId, key) => {
          const product = _.get(this.props, `product.products.data.${productId}`);
          const product_full_file_path = `${getServiceUrl()}/${_.get(product, 'image.path')}`;
          const brand_full_file_path = `${getServiceUrl()}/${_.get(product, 'brand.logo.path')}`;
          return (
            <div key={key} className="item">
              <div className="image">
                <Image src={product_full_file_path} alt={t(_.get(product, 'name'))} />
                <div className="cancel-btn">
                  <Icon type="close" onClick={() => this.handleCloseWishlist(productId)} />
                </div>
                <div className="detail">
                  <div className="left">
                    <div className="model">
                      {t('Models')}: {t(_.get(product, 'model'))}
                    </div>
                    <div className="category">
                      {t('Category')}: {t(_.get(product, 'category.name'))}
                    </div>
                  </div>
                  <div className="right">
                    <div className="brand">
                      <Image src={brand_full_file_path} alt={t(_.get(product, 'brand.name'))} />
                    </div>
                  </div>
                </div>
              </div>
              <FormItem
                colon={false}
                label={
                  <span>
                    {t('Quantity')}
                    <span className="text-red">*</span>
                  </span>
                }
              >
                {getFieldDecorator(`${productId}[quantity]`, {
                  initialValue: 1,
                  rules: [
                    {
                      required: true,
                      message: t('Please input quantity!')
                    }
                  ]
                })(<Input type="number" />)}
              </FormItem>
              <FormItem colon={false} label={t('Model')}>
                {getFieldDecorator(`${productId}[model]`)(<Input />)}
              </FormItem>
              <FormItem colon={false} label={t('More details (optional)')}>
                {getFieldDecorator(`${productId}[detail]`)(<Input />)}
              </FormItem>
            </div>
          );
        })}
        {errorMessage && <Alert message={errorMessage} type="warning" showIcon closable />}
        <FormItem style={{ textAlign: 'center' }}>
          <Button type="primary" htmlType="submit" className="wishlist-form-button" loading={submitting}>
            {t('Get Quote')}
          </Button>
        </FormItem>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/WishlistForm.js